import { Button, styled } from "@mui/material";

export const CustomButtonStyle = styled(Button, {
  shouldForwardProp: (props) => props !== "focusColor",
})((p) => ({
  "& .MuiTypography-root": {
    fontSize: "14px",
    top: p.value ? "0px" : "-5px",
    "@media (max-width: 2200px) and (min-width: 2000px)": {
      fontSize: "22px",
    },
    "@media (max-width: 2000px) and (min-width: 1800px)": {
      fontSize: "17px",
    },
    "@media (max-width: 1800px) and (min-width: 1400px)": {
      fontSize: "15px",
    },
    "@media (max-width: 1400px) and (min-width: 1000px)": {
      fontSize: "13px",
    },
    "@media (max-width: 1000px) and (min-width: 960px)": {
      fontSize: "12px",
    },
    "@media (max-width: 960px) and (min-width: 769px)": {
      fontSize: "12px",
    },
    "@media (max-width: 768px) and (min-width: 687px)": {
      fontSize: "14px",
    },
    "@media (max-width: 687px)": {
      fontSize: "12px",
    },
  },
  "& .MuiButtonBase-root": {
    fontSize: "14px",
    "@media (max-width: 2200px) and (min-width: 2000px)": {
      fontSize: "22px",
    },
    "@media (max-width: 960px) and (min-width: 769px)": {
      fontSize: "12px",
    },
    "@media (max-width: 768px) and (min-width: 687px)": {
      fontSize: "14px",
    },
    "@media (max-width: 687px)": {
      fontSize: "12px",
    },
  },
}));

export const CustomDisabledButton = styled(Button, {
  shouldForwardProp: (props) => props !== "focusColor",
})((p) => ({
  "& .MuiButtonBase-input.Mui-disabled": {
    color: "black",
    backgroundColor: "#E9E9E5",
    borderColor: "black",
    fontSize: "14px",
    top: p.value ? "0px" : "-5px",
    WebkitTextFillColor: "black",
    "@media (max-width: 960px) and (min-width: 688px)": {
      fontSize: "12px",
    },
    "@media (max-width: 687px)": {
      top: "0px",
      fontSize: "10px",
    }
  },
  "& .Mui-disabled .MuiOutlinedInput-notchedOutline": {
    borderColor: "black",
    fontSize: "14px",
    "@media (max-width: 960px) and (min-width: 769px)": {
      fontSize: "12px",
    },
    "@media (max-width: 768px) and (min-width: 687px)": {
      fontSize: "14px",
    },
    "@media (max-width: 687px)": {
      fontSize: "12px",
    },
  },
  "& .MuiInputLabel-root": {
    "&.Mui-disabled": {
      fontSize: "14px",
      color: "black",
      "@media (max-width: 960px) and (min-width: 769px)": {
        fontSize: "12px",
      },
      "@media (max-width: 768px) and (min-width: 687px)": {
        fontSize: "14px",
      },
      "@media (max-width: 687px)": {
        fontSize: "12px",
      },
    },
  },
  "& .css-j3ly30-MuiFormControl-root-MuiTextField-root": {
    "&.MuiButtonBase-input.Mui-disabled": {
      fontSize: "14px",
      "@media (max-width: 960px) and (min-width: 769px)": {
        fontSize: "12px",
      },
      "@media (max-width: 768px) and (min-width: 687px)": {
        fontSize: "14px",
      },
      "@media (max-width: 687px)": {
        fontSize: "12px",
      },
    },
  },
  "& .MuiOutlinedInput-input": {
    height: "12px",
  },
}));